import React from 'react';
import MainSidebar from './MainSidebar';
import { FiUsers, FiCalendar, FiDollarSign, FiClock, FiFileText } from 'react-icons/fi';

export default function HRMSidebar() {
  const menuItems = [
    {
      id: 'directory',
      title: 'Employees',
      links: [
        { path: '/hrm/employees', label: 'Directory', icon: FiUsers }
      ]
    },
    {
      id: 'attendance',
      title: 'Time & Attendance',
      links: [
        { path: '/hrm/leaves', label: 'Leaves', icon: FiCalendar },
        { path: '/hrm/presences', label: 'Presences', icon: FiClock }
      ]
    },
    {
      id: 'payroll',
      title: 'Payroll & Expenses',
      links: [
        { path: '/hrm/salaries', label: 'Salaries', icon: FiDollarSign },
        { path: '/hrm/expenses', label: 'Expense Reports', icon: FiFileText }
      ]
    }
  ];

  return <MainSidebar moduleName="Human Resources" menuItems={menuItems} />;
}